import i18n from '../utils/i18nService'

export enum MONTHES_SHORTLY {
	JAN = 'JAN',
	FEB = 'FEB',
	MAR = 'MAR',
	APR = 'APR',
	MAY = 'MAY',
	JUN = 'JUN',
	JUL = 'JUL',
	AUG = 'AUG',
	SEP = 'SEP',
	OCT = 'OCT',
	NOV = 'NOV',
	DEC = 'DEC'
}

export const getMonthes = () => ({
	[MONTHES_SHORTLY.JAN]: i18n.t('constants:jan'),
	[MONTHES_SHORTLY.FEB]: i18n.t('constants:feb'),
	[MONTHES_SHORTLY.MAR]: i18n.t('constants:mar'),
	[MONTHES_SHORTLY.APR]: i18n.t('constants:apr'),
	[MONTHES_SHORTLY.MAY]: i18n.t('constants:may'),
	[MONTHES_SHORTLY.JUN]: i18n.t('constants:jun'),
	[MONTHES_SHORTLY.JUL]: i18n.t('constants:jul'),
	[MONTHES_SHORTLY.AUG]: i18n.t('constants:aug'),
	[MONTHES_SHORTLY.SEP]: i18n.t('constants:sep'),
	[MONTHES_SHORTLY.OCT]: i18n.t('constants:oct'),
	[MONTHES_SHORTLY.NOV]: i18n.t('constants:nov'),
	[MONTHES_SHORTLY.DEC]: i18n.t('constants:dec')
})

// do not change
export const MONTHES_INDEXED = [
	MONTHES_SHORTLY.JAN,
	MONTHES_SHORTLY.FEB,
	MONTHES_SHORTLY.MAR,
	MONTHES_SHORTLY.APR,
	MONTHES_SHORTLY.MAY,
	MONTHES_SHORTLY.JUN,
	MONTHES_SHORTLY.JUL,
	MONTHES_SHORTLY.AUG,
	MONTHES_SHORTLY.SEP,
	MONTHES_SHORTLY.OCT,
	MONTHES_SHORTLY.NOV,
	MONTHES_SHORTLY.DEC
]

export enum QUARTERS_SHORTLY {
	'QTR-1' = 'QTR-1',
	'QTR-2' = 'QTR-2',
	'QTR-3' = 'QTR-3',
	'QTR-4' = 'QTR-4'
}

export const getQuarters = () => ({
	[QUARTERS_SHORTLY['QTR-1']]: i18n.t('constants:quarter1'),
	[QUARTERS_SHORTLY['QTR-2']]: i18n.t('constants:quarter2'),
	[QUARTERS_SHORTLY['QTR-3']]: i18n.t('constants:quarter3'),
	[QUARTERS_SHORTLY['QTR-4']]: i18n.t('constants:quarter4')
})

export const QUARTERS_INDEXED = [
	QUARTERS_SHORTLY['QTR-1'],
	QUARTERS_SHORTLY['QTR-2'],
	QUARTERS_SHORTLY['QTR-3'],
	QUARTERS_SHORTLY['QTR-4']
]
